import Highcharts from 'highcharts';
import { loadPolandMapData } from '../ranking-sm/maps.js';
import rankingResults from '../../../data/ranking_results.json';
import rankingData from '../../../data/ranking_data.json';

export default async function mapRanking(id) {
    if (!document.getElementById(id)) return;

    const mapData = await loadPolandMapData();
    const cityCoords = rankingData.cities;

    const rankings = [...rankingResults.cities]
        .sort((a, b) => b.score - a.score)
        .map((c, i) => ({
            city: c.city,
            score: c.score,
            rank: i + 2,
            lat: cityCoords[c.city]?.lat,
            lon: cityCoords[c.city]?.lon,
            name: `${i + 2}. ${c.city}`
        }))
        .filter(c => c.lat != null);

    const series = [];

    if (mapData) {
        series.push({
            type: 'map',
            mapData,
            showInLegend: false,
            enableMouseTracking: false,
            color: '#f0f0f0',
            borderColor: '#b0b0b0',
            borderWidth: 0.5,
            nullColor: '#f0f0f0'
        });
    }

    series.push({
        type: 'mappoint',
        name: 'Ranking',
        showInLegend: false,
        marker: {
            symbol: 'circle',
            radius: 5,
            lineColor: '#ffffff',
            lineWidth: 1.5,
            color: '#009c7f'
        },
        dataLabels: {
            enabled: true,
            format: '{point.name}',
            allowOverlap: true,
            x: 9,
            align: 'left',
            verticalAlign: 'middle',
            style: { fontSize: '13px', fontWeight: '600', color: '#1a1a1a', textOutline: '2px white' }
        },
        tooltip: {
            pointFormat: '<b>{point.name}</b><br/>{point.score}/1200 pts'
        },
        data: rankings.map(r => ({
            name: r.name,
            city: r.city,
            rank: r.rank,
            score: r.score,
            lat: r.lat,
            lon: r.lon,
            marker: {
                fillColor: r.rank === 2 ? '#C0C0C0' : r.rank === 3 ? '#CD7F32' : '#cccccc',
                color: '#009c7f',
                lineColor: '#ffffff',
                lineWidth: 1.5,
                symbol: 'circle',
                radius: 5,
            },
            dataLabels: {
                style: { fontSize: Math.round(30 - Math.log10(r.rank) * 14) + 'px' }
            }
        }))
    });

    Highcharts.mapChart(id, {
        chart: { backgroundColor: 'transparent', animation: false },
        title: { text: null },
        mapNavigation: { enabled: false },
        legend: { enabled: false },
        credits: { enabled: false },
        series
    });
}
